<template>
  <div
    :class="[
      'border rounded-3xl p-5 pricing_main_div',
      cardData.onFocus ? ' border-primaryColor border-4' : 'border-gray-300',
    ]"
  >
    <h4
      :class="[
        'text-xl font-semibold',
        cardData.onFocus ? ' text-primaryColor ' : ' text-gray-800',
      ]"
    >
      {{ cardData.title }}
    </h4>
    <p class="text-base font-medium text-gray-800 mt-5">
      {{ cardData.description }}
    </p>
    <h3 class="text-3xl font-semibold mt-5 mb-0">
      {{ activeTab === 'monthly' ? cardData.monthly : cardData.yearly }}
      <span class="text-base text-gray-700"
        >{{ cardData.title === 'Business' ? '/ month and up' : '/ month' }}
      </span>
    </h3>
    <!-- <p class=" italic text-base font-medium text-gray-700"> {{ activeTab === 'monthly' ? 'Per user' : 'Per user billed annually' }} </p> -->
    <button
      v-if="cardData.title !== 'Business'"
      :class="[
        'btn w-full hover:bg-primaryColor mt-2',
        cardData.onFocus ? ' btn-primary ' : 'btn-outline',
      ]"
    >
      Get Started
    </button>
    <a
    href="https://twitter.com/messages/14603308-1448512543505272835?recipient_id=14603308"
    target="_blank"
     v-if="cardData.title === 'Business'"
      :class="[
        'btn w-full hover:bg-primaryColor mt-2',
        cardData.onFocus ? ' btn-primary ' : 'btn-outline',
      ]"
    >
      Contact us
    </a>
    <ul :class="['mt-10']">
      <li
        v-for="(data, index) in cardData.keyPoints"
        :key="index + data.title"
        :class="['mt-5', index == 3 && 'mt-8', index === 6 && 'mt-8']"
      >
        <font-awesome-icon
          class="reaction text-gray-800 mr-4 font-thin"
          size="lg"
          :icon="['fas', 'check']"
        />
        {{ data.title }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PricingCardNew',
  props: ['cardData', 'activeTab', 'index'],
};
</script>

<style>
.pricing_main_div {
  width: 380px;
}
@media (max-width: 1250px) {
  .pricing_main_div {
    width: 350px;
  }
}
@media (max-width: 900px) {
  .pricing_main_div {
    width: 300px;
  }
}
</style>
